import { TimeObject } from "./types";

export function validSelectedDateAndTime(startDate: string, startTime: TimeObject, endDate: string, endTime: TimeObject){
  if(startDate === endDate){
    if(endTime.hours < startTime.hours || (endTime.hours == startTime.hours && endTime.minutes < startTime.minutes)){
      return false
    }
  }
  
  return true  
}
